exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".curated-addresses-list{width:100%;margin-top:12px}.curated-addresses-list-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;cursor:pointer}.location-display-name{font-size:18px;font-weight:700}.location-zone-display-name{font-size:16px;font-weight:500}.mobile-layout .curated-addresses-list{width:90%;margin-bottom:30px}.mobile-layout .location-display-name{font-size:16px}.mobile-layout .location-zone-display-name{font-size:14px}", ""]);

// exports
